<div>
    <medical-order-scann-control [medicalorderId]="medicalorderId"></medical-order-scann-control>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick($event)">Salir</button>
    </div>
</div>